import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timeline: {
		id: 'roadmap.standard-roadmap.healthcheck.timeline',
		defaultMessage: 'Timeline',
		description: 'Page heading. Shown on page where users view and manage their timeline',
	},
});
